import { render } from "./fileformatpopup.vue?vue&type=template&id=d394d4c2&scoped=true"
import script from "./fileformatpopup.js?vue&type=script&lang=js"
export * from "./fileformatpopup.js?vue&type=script&lang=js"

import "./fileformatpopup.vue?vue&type=style&index=0&id=d394d4c2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d394d4c2"]])

export default __exports__